export const ModalTypes = {
    info: { color: '#008aff', icon: 'bi-info-circle' },
    warning: { color: '#ff9447', icon: 'bi-exclamation-triangle' },
    danger: { color: '#e74c3c', icon: 'bi-exclamation-octagon' },
    reject: { color: '#e74c3c', icon: 'bi-x-circle' },
    success: { color: '#27ae60', icon: 'bi-check-circle' },
    confirm: { color: '#008aff', icon: 'bi-question-circle' }
};

export const ModalDefaults = {
    labelCol: 4,
    inputCol: 8,
    labelAlign: 'right',
    textAreaLabelPlacement: 'center'
};

export const TextAreaLabelPlacements = Object.freeze({
    TOP: 'top',
    CENTER: 'center',
    BOTTOM: 'bottom'
});

export const ReadOnlyStyles = Object.freeze({
    PLAIN: 'plain',
    DISABLED: 'disabled',
    INPUT: 'input'
});

export const ActionConfigs = {
    view:     { icon: 'bi-eye',             color: '#3b82f6', title: 'View',     btnClass: 'gm-btn-view'     },
    edit:     { icon: 'bi-pencil-square',   color: '#f59e0b', title: 'Edit',     btnClass: 'gm-btn-edit'     },
    delete:   { icon: 'bi-trash3',          color: '#ef4444', title: 'Delete',   btnClass: 'gm-btn-delete'   },
    accept:   { icon: 'bi-check-circle',    color: '#10b981', title: 'Accept',   btnClass: 'gm-btn-accept-row' },
    reject:   { icon: 'bi-x-circle',        color: '#ef4444', title: 'Reject',   btnClass: 'gm-btn-reject-row' },
    download: { icon: 'bi-download',        color: '#6366f1', title: 'Download', btnClass: 'gm-btn-download'  },
    print:    { icon: 'bi-printer',         color: '#64748b', title: 'Print',    btnClass: 'gm-btn-print'    },
    info:     { icon: 'bi-info-circle',     color: '#0ea5e9', title: 'Info',     btnClass: 'gm-btn-info'     }
};

export const Sizes = Object.freeze({
    SMALL: 'sm',
    MEDIUM: 'md',
    LARGE: 'lg',
    EXTRA_LARGE: 'xl',
    EXTRA_EXTRA_LARGE: 'xxl'
});

export const Types = Object.freeze({
    INFO: 'info',
    SUCCESS: 'success',
    WARNING: 'warning',
    DANGER: 'danger',
    CONFIRM: 'confirm',
    REJECT: 'reject'
});

export const FieldTypes = Object.freeze({
    TEXT: 'text',
    EMAIL: 'email',
    NUMBER: 'number',
    SELECT: 'select',
    DATEPICKER: 'datepicker',
    TEXTAREA: 'textarea',
    HIDDEN: 'hidden',
    HEADING: 'heading',
    COLUMNS: 'columns'
});

export const Align = Object.freeze({
    LEFT: 'left',
    CENTER: 'center',
    RIGHT: 'right'
});

export const Backdrop = Object.freeze({
    STATIC: 'static',
    TRUE: true,
    FALSE: false
});

export const ActionSizes = Object.freeze({
    SMALL: 'sm',
    MEDIUM: 'md',
    LARGE: 'lg'
});

export const Validators = {
    required: (v) => v !== null && v !== undefined && String(v).trim() !== '',
    minLength: (v, l) => String(v).length >= l,
    maxLength: (v, l) => String(v).length <= l,
    exactLength: (v, l) => String(v).length === l,
    discreteLength: (v, lens) => Array.isArray(lens) && lens.includes(String(v).length),
    pattern: (v, p) => p instanceof RegExp ? p.test(String(v)) : new RegExp(p).test(String(v)),
    email: (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v)),
    numeric: (v) => /^\d+$/.test(String(v)),
    alphanumeric: (v) => /^[a-z0-9]+$/i.test(String(v)),
    range: (v, min, max) => {
        const num = Number(v);
        if (min !== undefined && num < min) return false;
        if (max !== undefined && num > max) return false;
        return true;
    },
    url: (v) => /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([\/\w .-]*)*\/?$/.test(String(v))
};

export const Colors = Object.freeze({
    BLUE: '#008aff',
    GREEN: '#27ae60',
    RED: '#e74c3c',
    ORANGE: '#ff9447',
    AMBER: '#f59e0b',
    EMERALD: '#10b981',
    INDIGO: '#6366f1',
    SLATE: '#64748b',
    SKY: '#0ea5e9',
    ROSE: '#f43f5e',
    PRIMARY: '#3b82f6',
    SECONDARY: '#64748b',
    SUCCESS: '#10b981',
    DANGER: '#ef4444',
    WARNING: '#f59e0b',
    INFO: '#3b82f6'
});
